import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "card-header-row"
};
const _hoisted_2 = {
  class: "header-left"
};
const _hoisted_3 = {
  class: "header-title-row"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "card-status"
};
const _hoisted_6 = ["aria-label", "aria-expanded"];
const _hoisted_7 = {
  class: "task-panel four-col"
};
const _hoisted_8 = {
  key: 0,
  class: "empty-tip"
};
const _hoisted_9 = {
  class: "task-icon",
  "aria-hidden": "true"
};
const _hoisted_10 = ["href"];
const _hoisted_11 = ["title"];
const _hoisted_12 = ["title"];
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  class: "score"
};
const _hoisted_15 = {
  key: 2,
  class: "tile-hint"
};
const _hoisted_16 = {
  key: 0,
  class: "status-icon",
  "aria-hidden": "true"
};
const _hoisted_17 = ["href"];
import { ref, onMounted, onUnmounted, computed, watch } from 'vue';
import useMainStore, { storeToRefs } from '@views/main/main.store';
import { setFoldFunc, removeFoldFunc } from '@views/main/states/fold.state';
import initIncrementalUpdate from '../report-items/mixins/incrementalUpdate.mixin';
import sparklesIcon from './geo-analysis-sparkles.png';
const title = '站点基础信息检查';
const subtitle = '正在检查网站基础配置与可访问性';
export default /*@__PURE__*/_defineComponent({
  __name: 'GeoStage',
  props: {
    item: {},
    content: {}
  },
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const mainStore = useMainStore();
    const {
      incrementalMessageList
    } = storeToRefs(mainStore);
    const info = ref({});
    const subNodes = ref([]);
    const isFold = ref(false);
    const EXPECTED_SUB_CODES = [60201, 60202, 60203, 60204];
    let nextLoaded = false;
    const TASK_ICON_IDS = ['#geo-icon-doc', '#geo-icon-code', '#geo-icon-structure', '#geo-icon-page'];
    const getNodeIconId = index => TASK_ICON_IDS[index % TASK_ICON_IDS.length];
    const doneCount = computed(() => subNodes.value.filter(n => n.status === 3).length);
    const total = computed(() => subNodes.value.length);
    const isAllDone = computed(() => total.value > 0 && doneCount.value === total.value);
    const titleSuffix = computed(() => {
      if (info.value.executeStatus === 3) return `(已完成 ${total.value}/${total.value})`;
      if (info.value.executeStatus === 2) return '(失败)';
      if (total.value === 0) return '';
      if (isAllDone.value) return `(已完成 ${doneCount.value}/${total.value})`;
      return `(进行中 ${doneCount.value}/${total.value})`;
    });
    const STATUS_PILL = {
      0: {
        class: 'wait-pill',
        text: '待开始',
        iconId: ''
      },
      1: {
        class: 'run-pill',
        text: '检测中',
        iconId: '#geo-icon-status-loading'
      },
      2: {
        class: 'fail-pill',
        text: '检测失败',
        iconId: '#geo-icon-status-error'
      },
      3: {
        class: 'done-pill',
        text: '已完成',
        iconId: '#geo-icon-status-success'
      }
    };
    const getScoreSummary = node => {
      const data = node.data || {};
      if (data.geo_score !== undefined) return {
        label: 'GEO评分',
        value: data.geo_score
      };
      if (data.overall_score !== undefined) return {
        label: '综合评分',
        value: data.overall_score
      };
      if (data.technical_score !== undefined) return {
        label: '技术评分',
        value: data.technical_score
      };
      if (data.eeat_score !== undefined) return {
        label: 'E-E-A-T评分',
        value: data.eeat_score
      };
      if (data.schema_score !== undefined) return {
        label: '结构化评分',
        value: data.schema_score
      };
      if (data.average_score !== undefined) return {
        label: '平均分',
        value: data.average_score
      };
      if (data.crawler_access_score !== undefined) return {
        label: '爬虫访问评分',
        value: data.crawler_access_score
      };
      if (data.grade) return {
        label: '等级',
        value: data.grade
      };
      if (data.level) return {
        label: '等级',
        value: data.level
      };
      return null;
    };
    const toggleFold = val => {
      isFold.value = typeof val === 'boolean' ? val : !isFold.value;
    };
    const tryLoadNext = () => {
      if (nextLoaded || !props.item?.openAnimate) return;
      const allArrived = EXPECTED_SUB_CODES.every(code => subNodes.value.some(n => n.code === code));
      const noneRunning = subNodes.value.every(n => n.status !== 1);
      const stageFinished = info.value.executeStatus === 3 || info.value.executeStatus === 2;
      if (stageFinished || allArrived && noneRunning && subNodes.value.length > 0) {
        nextLoaded = true;
        mainStore.loadNextMsg(props.item);
      }
    };
    const {
      handleIncrementalMessage
    } = initIncrementalUpdate(async message => {
      if (props.item.id === message.id) {
        const {
          incrementalData,
          messageType,
          openAnimate
        } = message;
        const nodeName = message.nodeName || `节点${messageType}`;
        isFold.value = false;
        if (incrementalData.error) {
          const existing = subNodes.value.find(n => n.code === messageType);
          if (existing) {
            existing.status = 2;
            existing.data = {
              error: incrementalData.error
            };
          } else {
            subNodes.value.push({
              code: messageType,
              nodeName,
              status: 2,
              data: {
                error: incrementalData.error
              }
            });
          }
        } else {
          const existing = subNodes.value.find(n => n.code === messageType);
          const newStatus = openAnimate === 1 ? 1 : 3;
          if (existing) {
            existing.status = newStatus;
            existing.data = incrementalData;
          } else {
            subNodes.value.push({
              code: messageType,
              nodeName,
              status: newStatus,
              data: incrementalData
            });
          }
        }
        tryLoadNext();
      }
    });
    const initFromMessageContent = () => {
      const {
        messageContent
      } = info.value;
      if (!messageContent) return;
      Object.entries(messageContent).forEach(([code, nodeData]) => {
        const existing = subNodes.value.find(n => n.code === Number(code));
        if (existing) {
          existing.status = nodeData.status;
          existing.data = nodeData;
        } else {
          subNodes.value.push({
            code: Number(code),
            nodeName: nodeData.nodeName || `节点${code}`,
            status: nodeData.status,
            data: nodeData
          });
        }
      });
    };
    onUnmounted(() => {
      mainStore.componentFunMap.delete(props.item.id);
      if (props.item.id) removeFoldFunc(props.item.id);
    });
    watch(() => props.content, val => {
      if (!val) return;
      info.value = val;
      initFromMessageContent();
      tryLoadNext();
    });
    onMounted(() => {
      if (props.item.id) {
        mainStore.componentFunMap.set(props.item.id, handleIncrementalMessage);
        setFoldFunc(props.item.id, toggleFold);
      }
      try {
        info.value = props.content || {};
        initFromMessageContent();
        if (props.item.incrementalIds) {
          props.item.incrementalIds.forEach(id => {
            handleIncrementalMessage(incrementalMessageList.value[id]);
          });
        }
        tryLoadNext();
      } catch (error) {
        info.value = {};
      }
    });
    __expose({
      isFold,
      setIsFold: val => {
        isFold.value = val;
      }
    });
    return (_ctx, _cache) => {
      const _component_i_home_down = _resolveComponent("i-home-down");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("article", {
        class: _normalizeClass(["process-card basic-card", {
          'is-collapsed': isFold.value
        }])
      }, [_cache[1] || (_cache[1] = _createElementVNode("svg", {
        class: "geo-svg-sprite",
        "aria-hidden": "true",
        focusable: "false"
      }, [_createElementVNode("defs", null, [_createElementVNode("linearGradient", {
        id: "geo-grad-purple",
        x1: "0",
        y1: "0",
        x2: "24",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      }, [_createElementVNode("stop", {
        "stop-color": "#8d86ff"
      }), _createElementVNode("stop", {
        offset: "1",
        "stop-color": "#5b63f4"
      })]), _createElementVNode("linearGradient", {
        id: "geo-grad-green",
        x1: "0",
        y1: "0",
        x2: "24",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      }, [_createElementVNode("stop", {
        "stop-color": "#31d889"
      }), _createElementVNode("stop", {
        offset: "1",
        "stop-color": "#0fb66b"
      })]), _createElementVNode("linearGradient", {
        id: "geo-grad-red",
        x1: "0",
        y1: "0",
        x2: "24",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      }, [_createElementVNode("stop", {
        "stop-color": "#ff6565"
      }), _createElementVNode("stop", {
        offset: "1",
        "stop-color": "#ef3038"
      })])]), _createElementVNode("symbol", {
        id: "geo-icon-status-loading",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        d: "M12 4a8 8 0 1 0 8 8",
        fill: "none",
        stroke: "url(#geo-grad-purple)",
        "stroke-width": "2.4",
        "stroke-linecap": "round"
      }), _createElementVNode("path", {
        d: "M20 3.8v5h-5",
        fill: "none",
        stroke: "url(#geo-grad-purple)",
        "stroke-width": "2.4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })]), _createElementVNode("symbol", {
        id: "geo-icon-status-success",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "8.5",
        fill: "none",
        stroke: "url(#geo-grad-green)",
        "stroke-width": "2.4"
      }), _createElementVNode("path", {
        d: "m7.7 12 3 3.1 5.8-6.2",
        fill: "none",
        stroke: "#16bd72",
        "stroke-width": "2.4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })]), _createElementVNode("symbol", {
        id: "geo-icon-status-error",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "8.5",
        fill: "none",
        stroke: "url(#geo-grad-red)",
        "stroke-width": "2.4"
      }), _createElementVNode("path", {
        d: "M12 6.8v7",
        fill: "none",
        stroke: "#ef3038",
        "stroke-width": "2.8",
        "stroke-linecap": "round"
      }), _createElementVNode("circle", {
        cx: "12",
        cy: "17.5",
        r: "1.35",
        fill: "#ef3038"
      })]), _createElementVNode("symbol", {
        id: "geo-icon-doc",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        d: "M6 3.8h8.2L19 8.6v11.6H6V3.8Z",
        fill: "none",
        stroke: "url(#geo-grad-purple)",
        "stroke-width": "2",
        "stroke-linejoin": "round"
      }), _createElementVNode("path", {
        d: "M14 4v5h5",
        fill: "none",
        stroke: "#8176ff",
        "stroke-width": "2",
        "stroke-linejoin": "round"
      }), _createElementVNode("path", {
        d: "M9 12h6M9 15.5h6",
        stroke: "#8176ff",
        "stroke-width": "1.8",
        "stroke-linecap": "round"
      })]), _createElementVNode("symbol", {
        id: "geo-icon-code",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("rect", {
        x: "4",
        y: "4",
        width: "16",
        height: "16",
        rx: "2.6",
        fill: "url(#geo-grad-purple)"
      }), _createElementVNode("path", {
        d: "m10 8-4 4 4 4M14 8l4 4-4 4",
        fill: "none",
        stroke: "#fff",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })]), _createElementVNode("symbol", {
        id: "geo-icon-structure",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("rect", {
        x: "9",
        y: "3.5",
        width: "6",
        height: "5.4",
        rx: "1.2",
        fill: "none",
        stroke: "url(#geo-grad-purple)",
        "stroke-width": "2"
      }), _createElementVNode("rect", {
        x: "3.8",
        y: "15.1",
        width: "6",
        height: "5.4",
        rx: "1.2",
        fill: "none",
        stroke: "url(#geo-grad-purple)",
        "stroke-width": "2"
      }), _createElementVNode("rect", {
        x: "14.2",
        y: "15.1",
        width: "6",
        height: "5.4",
        rx: "1.2",
        fill: "none",
        stroke: "url(#geo-grad-purple)",
        "stroke-width": "2"
      }), _createElementVNode("path", {
        d: "M12 9v3.6M6.8 12.6h10.4M6.8 12.6v2.5M17.2 12.6v2.5",
        fill: "none",
        stroke: "#8176ff",
        "stroke-width": "2",
        "stroke-linecap": "round"
      })]), _createElementVNode("symbol", {
        id: "geo-icon-page",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("rect", {
        x: "4",
        y: "5",
        width: "16",
        height: "11.2",
        rx: "1.8",
        fill: "none",
        stroke: "url(#geo-grad-purple)",
        "stroke-width": "2.2"
      }), _createElementVNode("path", {
        d: "M9 20h6M12 16.4V20",
        fill: "none",
        stroke: "#8176ff",
        "stroke-width": "2",
        "stroke-linecap": "round"
      })])], -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        class: "card-sparkles-img",
        src: _unref(sparklesIcon),
        alt: ""
      }, null, 8, _hoisted_4), _createElementVNode("span", {
        class: "card-title truncat"
      }, _toDisplayString(title)), _createElementVNode("span", _hoisted_5, _toDisplayString(titleSuffix.value), 1)]), _createElementVNode("span", {
        class: "card-subtitle"
      }, _toDisplayString(subtitle))]), _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["collapse-button", {
          'is-fold': isFold.value
        }]),
        "aria-label": isFold.value ? '展开' : '收起',
        "aria-expanded": !isFold.value,
        onClick: _cache[0] || (_cache[0] = $event => toggleFold())
      }, [_createVNode(_component_el_icon, {
        class: "collapse-icon",
        color: "#4E5969"
      }, {
        default: _withCtx(() => [_createVNode(_component_i_home_down)]),
        _: 1
      })], 10, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [!subNodes.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, "等待分析结果...")) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(subNodes.value, (node, index) => {
        return _openBlock(), _createElementBlock("section", {
          key: node.code,
          class: _normalizeClass(["task-tile", [`is-${STATUS_PILL[node.status]?.class.replace('-pill', '')}`, {
            'has-error': node.data?.error
          }]])
        }, [(_openBlock(), _createElementBlock("svg", _hoisted_9, [_createElementVNode("use", {
          href: getNodeIconId(index)
        }, null, 8, _hoisted_10)])), _createElementVNode("div", null, [_createElementVNode("h3", {
          title: node.nodeName
        }, _toDisplayString(node.nodeName), 9, _hoisted_11), node.data?.error ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "tile-error",
          title: node.data.error
        }, _toDisplayString(node.data.error), 9, _hoisted_12)) : getScoreSummary(node) ? (_openBlock(), _createElementBlock("p", _hoisted_13, [_createTextVNode(_toDisplayString(getScoreSummary(node)?.label) + " ", 1), _createElementVNode("b", _hoisted_14, _toDisplayString(getScoreSummary(node)?.value), 1)])) : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(node.status === 1 ? '正在检测...' : '检测项目'), 1)), _createElementVNode("span", {
          class: _normalizeClass(["tile-state", STATUS_PILL[node.status]?.class])
        }, [STATUS_PILL[node.status]?.iconId ? (_openBlock(), _createElementBlock("svg", _hoisted_16, [_createElementVNode("use", {
          href: STATUS_PILL[node.status].iconId
        }, null, 8, _hoisted_17)])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(STATUS_PILL[node.status]?.text || '待开始'), 1)], 2)])], 2);
      }), 128))])], 2);
    };
  }
});